import { render, staticRenderFns } from "./NewIncidenceForm.vue?vue&type=template&id=1475e591&"
import script from "./NewIncidenceForm.vue?vue&type=script&lang=js&"
export * from "./NewIncidenceForm.vue?vue&type=script&lang=js&"
import style0 from "./NewIncidenceForm.vue?vue&type=style&index=0&id=1475e591&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports